{
  "es": {
    "task": {
      "actions": {
        "create": "Tarea",
        "create_and_send": "Crear y enviar",
        "delete": "Eliminar tarea",
        "keep_as_draft": "Mantener como borrador",
        "open_in_project": "Abrir la tarea en el proyecto",
        "remove_from_unit": "Quitar la tarea de esta unidad",
        "save_as_draft": "Guardar como borrador",
        "update": "Editar tarea"
      },
      "attributes": {
        "assignments_count": "Asignaciones",
        "category": "Forma de completar",
        "created_at": "Creado",
        "description": "Descripción",
        "phase": "Fase",
        "title": "Título"
      },
      "categories": {
        "confirmation": "Confirmación",
        "upload": "Subida de documento"
      },
      "categories_info": {
        "confirmation": "La persona asignada la marca cuando está hecha.",
        "upload": "La persona asignada tiene que subir un archivo para completarla."
      },
      "confirm": {
        "delete_accept": "Eliminar en todas partes",
        "delete_body": "Esto elimina {count} tarea en {units}, aunque ya esté completada. | Esto elimina las {count} tareas en {units}, también las ya completadas.",
        "delete_body_empty": "Esto elimina la tarea.",
        "delete_body_project": "Esto elimina la tarea y su responsable. | Esto elimina la tarea y sus {count} responsables.",
        "delete_cancel": "Conservar la tarea",
        "delete_header": "¿Eliminar «{title}»?",
        "delete_silent": "No se notifica a nadie, y las notificaciones ya enviadas no se retiran.",
        "publish_body": "Creamos {tasks} en {units} y las enviamos a sus responsables. Cada tarea queda como Abierta hasta que se complete.",
        "publish_body_project": "Creamos {tasks} en este proyecto y las enviamos a sus responsables. Cada tarea queda como Abierta hasta que se complete.",
        "publish_header": "¿Crear y enviar esta tarea?",
        "publish_info": "Los responsables reciben un correo al instante. Guárdala como borrador si todavía no quieres enviarla.",
        "remove_from_unit_accept": "Quitar de la unidad",
        "remove_from_unit_body": "Esto quita a todos los responsables de esta tarea en esta unidad. La tarea y sus otras unidades quedan intactas.",
        "remove_from_unit_customers": "Los clientes de esta unidad dejan de verla en su portal.",
        "remove_from_unit_header": "¿Quitar «{title}» de esta unidad?"
      },
      "deep_link": {
        "show_all": "Mostrar todas las tareas",
        "single": "Estás viendo una tarea."
      },
      "empty": {
        "filtered_description": "No se encontró nada con los filtros que elegiste. Bórralos para ver todas las tareas.",
        "filtered_description_project": "No se encontró nada con los filtros que elegiste. Bórralos para ver todas las tareas de este proyecto.",
        "filtered_title": "Ninguna tarea coincide con tus filtros",
        "none_description": "Crea una tarea y asígnala a tu equipo o a los clientes de una o más unidades. Aparece aquí en cuanto la envíes.",
        "none_description_sup": "Crea una tarea y asígnala a tu equipo o a tus clientes. Aparece aquí en cuanto la envíes.",
        "none_title": "Aún no hay tareas"
      },
      "filters": {
        "phase_none": "Sin fase",
        "search": "Buscar tarea"
      },
      "form": {
        "category_subtitle": "Elige cómo la persona asignada marca la tarea como completada",
        "category_title": "¿Cómo se completa?",
        "description_help": "Visible para todos los que reciben esta tarea.",
        "description_placeholder": "Añade detalles o instrucciones",
        "edit_info_assignments": "Los responsables, las unidades y las fechas límite los gestionas por responsable en la lista de tareas.",
        "edit_info_assignments_project": "Los responsables y las fechas límite los gestionas por responsable en la lista de tareas.",
        "edit_info_fields": "Aquí editas el título y la descripción.",
        "edit_info_fields_phase": "Aquí editas el título, la descripción y la fase.",
        "heading_create": "Nueva tarea",
        "heading_update": "Editar tarea",
        "phase_help_create": "Vincula esta tarea a una fase del flujo de trabajo. La fase solo se completa cuando todas sus tareas están terminadas.",
        "phase_help_update": "Cada unidad que ha llegado a la nueva fase, o ya la ha pasado, ve esta tarea de inmediato. Las unidades que aún no han llegado la ven en cuanto lleguen.",
        "phase_help_update_project": "Si este proyecto ha llegado a la nueva fase, o ya la ha pasado, sus responsables ven esta tarea de inmediato. Si no, la ven en cuanto el proyecto llegue.",
        "scope_headline": "Se creará y enviará {count} tarea | Se crearán y enviarán {count} tareas",
        "scope_project": "{assignees} en este proyecto",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "¿Qué hay que hacer?",
        "units_selected": "{selected} de {count} unidad seleccionada | {selected} de {count} unidades seleccionadas",
        "units_title": "Qué unidades"
      },
      "labels": {
        "assignees_count": "{count} responsable | {count} responsables",
        "created_by": "Creado por {name} · {date}",
        "created_on": "Creado el {date}",
        "required": "Este campo es obligatorio",
        "set_all_assignees": "Aplicar al responsable | Aplicar a los {count} responsables",
        "still_to_do": "{count} pendiente | {count} pendientes",
        "tasks_count": "{count} tarea | {count} tareas",
        "units_count": "{count} unidad | {count} unidades",
        "units_required": "Selecciona al menos una unidad"
      },
      "toasts": {
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "remove_from_unit": "Tarea quitada de esta unidad",
        "update": "Tarea actualizada"
      }
    }
  }
}
